export default "__VITE_ASSET__CyYv3TV6__"